// extracted by mini-css-extract-plugin
export var oopsPage = "oops-module--oopsPage--5fde1";
export var oopsPage__background = "oops-module--oopsPage__background--e63a5";
export var oopsPage__clues = "oops-module--oopsPage__clues--58358";
export var oopsPage__cluesButton = "oops-module--oopsPage__cluesButton--5ff48";
export var oopsPage__dateLine = "oops-module--oopsPage__dateLine--1f7d9";
export var oopsPage__imageCredit = "oops-module--oopsPage__imageCredit--53dc1";
export var oopsPage__imageCreditName = "oops-module--oopsPage__imageCreditName--25d9e";